import { Component, Input, NgModule, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { WRxBase } from '@wipo/w-angular/shared';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'w-block-ui',
    template: `
<div *ngIf="blocked" class="b-infobox-background"></div>
<div *ngIf="blocked" class="b-infobox b-infobox--has-spinner">
  <div class="b-infobox__title">{{title}}</div>
  <div class="b-infobox__text">
    <p>{{text}}</p>
  </div>
</div>
  `, host: {
        '[style.position]': '\'fixed\'',
        '[style.zIndex]': 'zIndex',
        '[style.height]': '\'100vh\'',
        '[style.top]': '0',
        '[style.left]': '0'
    },
    standalone: false
})
/*
@id w-block-ui
@name w-block-ui
@status release
@description
*/
export class WBlockUiComponent extends WRxBase implements OnInit {

  @Input() blocked: boolean = false; // blocking state, alternatively use blockStream Observable
  @Input() title = 'Processing';
  @Input() text = 'Please wait...';
  @Input() zIndex: number = 3000; // level of blocking layer, assign larger if any objects on page still accessible
  @Input() blockStream?: Observable<boolean>; // provide block/unblock state
  ngOnInit(): void {
    if (this.blockStream) {
      this.blockStream.pipe(takeUntil(this.destruction)).subscribe((state: boolean) => {
        this.blocked = state;
      });
    }
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [WBlockUiComponent],
  declarations: [WBlockUiComponent]
})
export class WBlockUiModule { }
